<script setup>
import { computed } from 'vue'

const props = defineProps({
    data:  { type: Array,  default: () => [] },
    color: { type: String, default: '#2A6FDB' },
    w:     { type: Number, default: 78 },
    h:     { type: Number, default: 26 },
})

const id = Math.random().toString(36).slice(2, 7)

const path = computed(() => {
    const data = props.data
    if (!data.length) return { d: '', area: '' }

    const pad = 2
    const min = Math.min(...data)
    const max = Math.max(...data)
    const rng = (max - min) || 1

    const pts = data.map((v, i) => {
        const x = pad + (i / (data.length - 1)) * (props.w - 2 * pad)
        const y = props.h - pad - ((v - min) / rng) * (props.h - 2 * pad)
        return [x, y]
    })

    const d    = pts.map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(' ')
    const last = pts[pts.length - 1]
    const first = pts[0]
    const area = `${d} L${last[0].toFixed(1)} ${props.h} L${first[0].toFixed(1)} ${props.h} Z`

    return { d, area }
})
</script>

<template>
    <svg :viewBox="`0 0 ${w} ${h}`" preserveAspectRatio="none" :style="{ width: w + 'px', height: h + 'px' }">
        <defs>
            <linearGradient :id="`sg-${id}`" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" :stop-color="color" stop-opacity="0.22"/>
                <stop offset="1" :stop-color="color" stop-opacity="0"/>
            </linearGradient>
        </defs>
        <path :d="path.area" :fill="`url(#sg-${id})`"/>
        <path :d="path.d" fill="none" :stroke="color" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
